export const GET_CHATLIST_REQUEST = 'GET_CHATLIST_REQUEST';
export const GET_CHATLIST_SUCCESS = 'GET_CHATLIST_SUCCESS';
export const GET_CHATLIST_FAILURE = 'GET_CHATLIST_FAILURE';
